export default __webpack_public_path__ + "static/media/ColdwellPreview.f3b4904c.jpg";